import { render, staticRenderFns } from "./editlog.vue?vue&type=template&id=3684b828"
import script from "./editlog.vue?vue&type=script&lang=js"
export * from "./editlog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports